export default __webpack_public_path__ + "static/media/PSD.3a181fba.png";